class MenuDrawer extends SideDrawer {
  constructor() {
    super();
    this.moved = false;
    this.header = this.header || document.querySelector('.header-wrapper');
  }

  open(triggeredBy) {
    if (this.header) {
      this.header.classList.add('open-menu-drawer');
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
    }
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);
    window.addEventListener('resize', this.onResize);
    super.open(triggeredBy);
  }

  close() {
    super.close();
    if (this.header) {
      this.header.classList.remove('open-menu-drawer');
      document.documentElement.style.removeProperty('--header-bottom-position');
    }
    document.body.removeEventListener('click', this.onBodyClickEvent);
    window.removeEventListener('resize', this.onResize);
  }

  onBodyClick(event) {
    if (!this.activeElement.contains(event.target) && !this.contains(event.target)) {
      this.close();
    }
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('menu-drawer', MenuDrawer);

if (!customElements.get('menu-details')) {
  customElements.define('menu-details',
    class MenuDetails extends HTMLElement {
      constructor() {
        super();
        this.summary.addEventListener('click', this.onSummaryClick.bind(this));
        this.button.addEventListener('click', this.onButtonClick.bind(this));
      }

      get parent() {
        return this.closest('[data-menu-details-parent]');
      }

      get details() {
        return this.querySelector('details');
      }

      get summary() {
        return this.querySelector('summary');
      }

      get button() {
        return this.querySelector('button');
      }

      setMegaMenuOpen() {
        const megaMenu = this.querySelector('mega-menu');
        megaMenu?.setAttribute('open', true);
      }
  
      setMegaMenuClose() {
        const megaMenu = this.querySelector('mega-menu');
        megaMenu?.removeAttribute('open');
      }

      onSummaryClick() {
        this.setMegaMenuOpen();
        setTimeout(() => {
          this.parent.classList.add('active');
          this.classList.add('active');
          this.setAttribute('open', true);
          this.details.setAttribute('open', true);
          this.summary.setAttribute('aria-expanded', true);
        }, 100);
      }

      onButtonClick() {
        this.setMegaMenuClose();
        this.parent.classList.remove('active');
        this.classList.remove('active');
        this.removeAttribute('open');
        this.details.removeAttribute('open');
        this.summary.setAttribute('aria-expanded', false);
      }
    }
  )
}

if (!customElements.get('menu-disclosure')) {
  customElements.define('menu-disclosure',
    class MenuDisclosure extends HTMLElement {
      constructor() {
        super();
        this._open = this.details.hasAttribute('open');
        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
      }

      get open() {
        return this._open
      }

      set open(value) {
        value = Boolean(value);
        if (value !== this._open) {
          this._open = value;
          if (value) {
            this.details.setAttribute('open', '');
            this.classList.add('active');
          } else {
            this.details.removeAttribute('open');
            this.classList.remove('active');
          }
        }

        this.details.setAttribute('aria-expanded', value ? 'true' : 'false');
        this.dispatchEvent(new CustomEvent('toggle', { bubbles: true, detail: { current: this } }));
      }

      get details() {
        return this._details || this.querySelector('details')
      }

      get summaryElement() {
        return this._summaryElement || this.querySelector('summary')
      }

      get contentElement() {
        return this._contentElement || this.querySelector('summary + *')
      }

      connectedCallback() {
        this.summaryElement?.addEventListener('click', this.onSummaryClick);
        this.details.addEventListener('keyup', this.onKeyUp);
      }

      disconnectedCallback() {
        this.summaryElement?.removeEventListener('click', this.onSummaryClick);
        this.details.removeEventListener('keyup', this.onKeyUp);
      }

      onSummaryClick(event) {
        event.preventDefault();
        this.toggle();
      }

      toggle(forceState = !this.open) {
        this.open = forceState;
      }

      openDetails() {
        this.open = true;
      }

      closeDetails() {
        this.open = false;
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.closeDetails();
        }
      }
    }
  )
}